import React, { useMemo } from "react";
import { useI18n } from "@core/i18n/i18n";
import { useNavigate } from "@core/routing/use-navigate";
import { Button } from "@ui/components/buttons/button";
import { RoutesPath } from "@ui/navigation/routes";
import { useDimensions } from "@ui/hooks/use-dimensions";
import { useExercisePage } from "@ui/pages/exercise/hooks/use-exercise-page";

interface CreateProgramButtonProps {
	className?: string;
}

export const CreateProgramButton: React.FC<CreateProgramButtonProps> = ({ className }) => {
	const { format } = useI18n();
	const navigate = useNavigate();
	const { isDesktop } = useDimensions();
	const { selectedExercises } = useExercisePage();

	const label = useMemo(
		() =>
			isDesktop
				? format("exerciseListing.createProgramButton")
				: format("exerciseListing.createProgramButtonMobile", { count: selectedExercises.length }),
		[format, isDesktop, selectedExercises.length],
	);

	return (
		<Button
			className={className}
			label={label}
			onClick={() =>
				navigate(RoutesPath.TemplateBuilder, {
					state: { preSelectedExercises: selectedExercises },
				})
			}
		/>
	);
};
